import React from "react";
import { ArrowRight } from "lucide-react";
import "../sass/landing/cta.scss";
import { scrollToSection } from "./landing/scroll";

const CtaBanner = () => (
  <section className="lp-cta" aria-labelledby="cta-title">
    <div className="lp-shell">
      <div className="lp-cta__heading">
        <h2 id="cta-title" className="lp-cta__title">Menos coisas na cabeça.</h2>
        <p className="lp-cta__statement">Mais espaço para atender.</p>
      </div>

      <div className="lp-cta__row">
        <p className="lp-cta__text">
          Agenda, confirmações, cobranças, prontuário e financeiro como partes
          da mesma rotina. Experimente por 7 dias com a sua agenda de verdade.
        </p>

        <div className="lp-cta__actions">
          <button
            type="button"
            className="lp-button lp-button--light"
            onClick={() => scrollToSection("planos")}
          >
            Começar meus 7 dias grátis
            <ArrowRight size={18} aria-hidden="true" />
          </button>
          <button
            type="button"
            className="lp-link lp-link--light"
            onClick={() => scrollToSection("como-funciona")}
          >
            Rever como funciona
          </button>
        </div>
      </div>

      <p className="lp-cta__trial">
        O cartão é solicitado no cadastro, mas a cobrança começa somente após
        o período de teste. Sem fidelidade.
      </p>
    </div>
  </section>
);

export default CtaBanner;
